import api from '../../../services/api';
import { PanelError } from '../../performance-operations/config';

// PM analitik P5 — E08 kalibrasyon çalışma alanı ekleri (analiz §11). Uçlar (erişim mevcut oturum kuralıyla aynı: PM.Write ya da üye):
//   GET v1/calibration-sessions/{id}/workspace/summary          Oturum Özeti: M03, M26–M28 (onaylı son), öneri ayrı, M70, adımlar
//   GET v1/calibration-sessions/{id}/workspace/distribution     Dağılım: aynı çalışan kümesiyle önce / sonra (öneri) + referans
//   GET v1/calibration-sessions/{id}/workspace/rows             Liste: çalışma tablosu (sayfalı) + seçilebilir soru sütunları
//   GET v1/calibration-sessions/{id}/workspace/questions        seçilebilir likert soruları (dönem formu)
//   GET v1/calibration-sessions/{id}/workspace/evidence/{rid}   kanıt paneli (hedef, yetkinlik, taşıma geçmişi, inceleme notu)
//   PUT v1/calibration-sessions/{id}/workspace/reviews/{rid}    toplantı öncesi inceleme notu (expectedVersion; çakışma 409)
// api.js GET'te reject ETMEZ (sinyal res.data.status); PUT hatasında tost interceptor'da.

export const TAB_MATRIX = 'matrix';
export const TAB_LIST = 'list';
export const TAB_DISTRIBUTION = 'distribution';
export const TAB_SUMMARY = 'summary';
export const WORKSPACE_TABS = [TAB_MATRIX, TAB_LIST, TAB_DISTRIBUTION, TAB_SUMMARY];

export const DIRECTIONS = ['up', 'down', 'equal', 'none'];
export const REVIEW_STATUSES = ['pending', 'reviewed', 'discuss'];
export const MAX_QUESTIONS = 5;

const payload = (res) => (res?.data?.status ? res.data.data : undefined);

async function get(url, params) {
  const res = await api.get(url, params ? { params } : undefined);
  const data = payload(res);
  if (data === undefined) throw new PanelError(res?.data?.message || 'error');
  return data;
}

const base = (sessionId) => `/v1/calibration-sessions/${sessionId}/workspace`;

export const fetchWorkspaceSummary = (sessionId) => get(`${base(sessionId)}/summary`);
export const fetchWorkspaceDistribution = (sessionId) => get(`${base(sessionId)}/distribution`);
export const fetchWorkspaceQuestions = (sessionId) => get(`${base(sessionId)}/questions`);
export const fetchEvidence = (sessionId, recordId) => get(`${base(sessionId)}/evidence/${recordId}`);

/** Liste süzgeçleri → uç parametreleri (analiz E08: puan bandı, değişiklik yönü, gerekçe eksik, inceleme durumu). */
export function rowParams(rowFilters, questionIds, pageNumber, pageSize) {
  const f = rowFilters || {};
  return {
    ...(f.levelId ? { 'levelId[in]': f.levelId } : {}),
    ...(f.direction ? { 'direction[in]': f.direction } : {}),
    ...(f.missingJustification ? { missingJustification: 'true' } : {}),
    ...(f.reviewStatus ? { 'reviewStatus[in]': f.reviewStatus } : {}),
    ...(f.search ? { search: f.search } : {}),
    ...(questionIds?.length ? { questionIds: questionIds.join(',') } : {}),
    pageNumber,
    pageSize,
  };
}

export const fetchRows = async (sessionId, rowFilters, questionIds, pageNumber, pageSize) => {
  const data = await get(`${base(sessionId)}/rows`, rowParams(rowFilters, questionIds, pageNumber, pageSize));
  return { rows: Array.isArray(data) ? data : (data?.data || []), total: data?.totalRowCount ?? 0 };
};

/** İnceleme notu kaydı; başarısızlıkta (409 sürüm çakışması dahil) null — tost interceptor'da. */
export async function saveReview(sessionId, recordId, body) {
  try {
    const res = await api.put(`${base(sessionId)}/reviews/${recordId}`, body);
    return res?.data?.data || null;
  } catch {
    return null;
  }
}

export const signedDiff = (v, format) => (v == null ? '-' : `${v > 0 ? '+' : ''}${format(v)}`);
